import React from 'react';
import { Link } from 'react-router-dom';

function Profile() {
    const user = window.CURRENT_USER || {};

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold text-slate-800 mb-6">Profile</h1>

            <div className="bg-white rounded-lg shadow p-6 space-y-6">
                <div className="flex items-center gap-4">
                    <div className="w-20 h-20 bg-indigo-600 rounded-full flex items-center justify-center text-white text-3xl font-bold">
                        {(user.name || user.email || 'U')[0].toUpperCase()}
                    </div>
                    <div>
                        <h2 className="text-xl font-semibold text-slate-800">{user.name || 'User'}</h2>
                        <p className="text-slate-500">{user.email}</p>
                    </div>
                </div>

                <div className="border-t pt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="text-sm font-semibold text-slate-500">Name</label>
                        <p className="text-lg text-slate-800 mt-1">{user.name || 'N/A'}</p>
                    </div>

                    <div>
                        <label className="text-sm font-semibold text-slate-500">Email</label>
                        <p className="text-lg text-slate-800 mt-1">{user.email || 'N/A'}</p>
                    </div>

                    {user.phone && (
                        <div>
                            <label className="text-sm font-semibold text-slate-500">Phone</label>
                            <p className="text-lg text-slate-800 mt-1">{user.phone}</p>
                        </div>
                    )}
                </div>

                <div className="border-t pt-6">
                    <div className="bg-slate-50 p-4 rounded-lg">
                        <p className="text-sm text-slate-600">
                            Profile editing coming soon. For now, please contact your administrator to update your profile information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
